import AuthService from './AuthService';

import apiService from '../Api';
import dataStoreService from '../DataStore';

export default new AuthService(apiService, dataStoreService);
